import { RequestStatus } from '@lib/plugin-redux-core';
import { useSelector, shallowEqual } from 'react-redux';
import { getFolderByIdStatusSelector, spaceObjectsSelector } from 'redux/space';

export const useSpaceContext = () => {
  const { spaceObjects, getFolderByIdStatus } = useSelector(
    (state) => ({
      spaceObjects: spaceObjectsSelector(state),
      getFolderByIdStatus: getFolderByIdStatusSelector(state),
    }),
    shallowEqual,
  );

  const isLoading = !spaceObjects || getFolderByIdStatus === RequestStatus.EXECUTE;

  return { isLoading };
};
